"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/testimonialSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSectionTestimonialTwosItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient22.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" */
    src: string;
    /** Detected variants: "The emergency department responded promptly and efficiently when I arrived with severe pain. The doctors didn’t rush and made sure I understood. Best healthcare experiences" | "The care I received at this hospital was exceptional. The doctors explained everything clearly, the nurses were incredibly kind, and the facilities were spotless. I felt safe, supported, and genuinely cared for throughout my stay. Truly one of the best healthcare experiences." | "Exceptional service and a friendly atmosphere. The staff is knowledgeable and truly cares about their patients health, ensuring every visit is enjoyable." */
    p0Text: ReactNode;
    /** Detected variants: "Daniel Carter" | "Jeni Adams" | "Mike Smith" | "Mark Andrew" */
    h30Text: ReactNode;
    /** Detected variants: "Dallas, CA" | "Los Boston, USA" | "San Francisco, CA" */
    p0P0Text: ReactNode;
    /** Detected variants: "testimonial-item-two" */
    className?: string;
    /** Detected variants: "testimonial-author-img" */
    div0ClassName?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "rounded-circle" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "quote-icon" */
    div1ClassName?: string;
    /** Detected variants: "quote" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/quote-icon-01.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "testimonial-content" */
    div2ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-author-info" */
    div3ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "author-location" */
    p0ClassName2?: string;
    ratingItems?: TestimonialSectionFaSolidFaStarFilled1sItem[];
};

type TestimonialSectionFaSolidFaStarFilled1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star filled me-1" | "fa-solid fa-star filled" */
    className: string;
};
export type HomeTwoTestimonialSectionGeneratedProps = {
    /** Default: "Client Reviews" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "What Our Patients" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Say About Us" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv3Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<ComponentProps<"h3">>);
    testimonialSectionTestimonialTwos: TestimonialSectionTestimonialTwosItem[];
    testimonialSectionTestimonialTwosItemWrapper?: (item: TestimonialSectionTestimonialTwosItem, content: ReactNode) => ReactNode;
    testimonialSectionTestimonialTwosRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionTestimonialTwosImageVisible?: boolean;
    testimonialSectionTestimonialTwosImageRenderer?: (item: TestimonialSectionTestimonialTwosItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTestimonialTwosH3Visible?: boolean;
    testimonialSectionTestimonialTwosH3Renderer?: (item: TestimonialSectionTestimonialTwosItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTestimonialTwosImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionTestimonialTwosH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<ComponentProps<"h3">>);
    testimonialSectionTestimonialTwosSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialSectionTestimonialTwosItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    testimonialSectionFaSolidFaStarFilled1sItemWrapper?: (item: TestimonialSectionFaSolidFaStarFilled1sItem, content: ReactNode) => ReactNode;
    testimonialSectionFaSolidFaStarFilled1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeTwoTestimonialSectionGenerated: FC<HomeTwoTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Client Reviews",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "What Our Patients",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Say About Us",
    sectionDiv0Swiper0SwiperProps,
    swiperSlideDiv0ImageWithBasePath0ImageProps,
    swiperSlideDiv1ImageWithBasePath0ImageProps,
    swiperSlideDiv3Div0H30H3Props,
    swiperSlideSwiperSlideProps,
    testimonialSectionTestimonialTwos,
    testimonialSectionTestimonialTwosItemWrapper,
    testimonialSectionTestimonialTwosRenderer,
    testimonialSectionTestimonialTwosImageVisible,
    testimonialSectionTestimonialTwosImageRenderer,
    testimonialSectionTestimonialTwosH3Visible,
    testimonialSectionTestimonialTwosH3Renderer,
    testimonialSectionTestimonialTwosImageProps,
    testimonialSectionTestimonialTwosH3Props,
    testimonialSectionTestimonialTwosSwiperSlideProps,
    testimonialSectionFaSolidFaStarFilled1sItemWrapper,
    testimonialSectionFaSolidFaStarFilled1sRenderer,
}) => {
    return (
        <section className="section testimonial-section-two">
            <div className="container-fluid">
                <div className="section-header section-header-two">
                    <div className="section-sub-title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title mb-0" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <Swiper className="testimonial-slider-two" modules={[FreeMode]} freeMode={true} centeredSlides={true} slidesPerView={"auto"} speed={2000} loop={true} spaceBetween={24} allowTouchMove={true} breakpoints={{
                    768: {
                        slidesPerView: 2,
                        centeredSlides: true
                    },
                    992: {
                        slidesPerView: 3,
                        centeredSlides: true
                    }
                }} {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {renderCollectionNode(
                        testimonialSectionTestimonialTwos,
                        (item: TestimonialSectionTestimonialTwosItem) => (
                            <SwiperSlide className={item.className ?? "testimonial-item-two"} {...(typeof testimonialSectionTestimonialTwosSwiperSlideProps === "function" ? testimonialSectionTestimonialTwosSwiperSlideProps(item) : (testimonialSectionTestimonialTwosSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                <div className={item.div0ClassName ?? "testimonial-author-img"}>
                                    {renderItemNode(testimonialSectionTestimonialTwosImageVisible, testimonialSectionTestimonialTwosImageRenderer, item, (
                                        <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "rounded-circle"} alt={item.alt ?? "patient"} {...(typeof testimonialSectionTestimonialTwosImageProps === "function" ? testimonialSectionTestimonialTwosImageProps(item) : (testimonialSectionTestimonialTwosImageProps ?? {}))} {...(typeof swiperSlideDiv0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                                <div className={item.div1ClassName ?? "quote-icon"}>
                                    {renderItemNode(testimonialSectionTestimonialTwosImageVisible, testimonialSectionTestimonialTwosImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/quote-icon-01.svg"} alt={item.imageWithBasePath0Alt ?? "quote"} {...(typeof testimonialSectionTestimonialTwosImageProps === "function" ? testimonialSectionTestimonialTwosImageProps(item) : (testimonialSectionTestimonialTwosImageProps ?? {}))} {...(typeof swiperSlideDiv1ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv1ImageWithBasePath0ImageProps(item) : (swiperSlideDiv1ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                                <div className={item.div2ClassName ?? "testimonial-content"}>
                                    <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                </div>
                                <div className={item.div3ClassName ?? "testimonial-author-info"}>
                                    <div>
                                        {renderItemNode(testimonialSectionTestimonialTwosH3Visible, testimonialSectionTestimonialTwosH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof testimonialSectionTestimonialTwosH3Props === "function" ? testimonialSectionTestimonialTwosH3Props(item) : (testimonialSectionTestimonialTwosH3Props ?? {}))} {...(typeof swiperSlideDiv3Div0H30H3Props === "function" ? swiperSlideDiv3Div0H30H3Props(item) : (swiperSlideDiv3Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName2 ?? "author-location"}>{item.p0P0Text}</p>
                                    </div>
                                    <div className="rating">
                                        {renderCollectionNode(
                                            item.ratingItems ?? [],
                                            (item: TestimonialSectionFaSolidFaStarFilled1sItem) => (
                                                <i className={item.className} key={item.key} />
                                            ),
                                            testimonialSectionFaSolidFaStarFilled1sItemWrapper,
                                            testimonialSectionFaSolidFaStarFilled1sRenderer
                                        )}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ),
                        testimonialSectionTestimonialTwosItemWrapper,
                        testimonialSectionTestimonialTwosRenderer
                    )}
                </Swiper>
            </div>
        </section>
    );
};

export default HomeTwoTestimonialSectionGenerated;
